import { useEffect, useState } from "react";
import { Check, Loader2 } from "lucide-react";
import { t } from "@/i18n";

const STEPS = [t("analyzingSteps.lecture_de_votre_carte"), t("analyzingSteps.identification_des_plats"), t("analyzingSteps.analyse_des_prix"), t("analyzingSteps.recherche_d_opportunites")];
const DELAYS = [3500, 5000, 4500];

export default function AnalyzingSteps({ fileName }) {
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (step >= STEPS.length - 1) return;
    const t = setTimeout(() => setStep((s) => s + 1), DELAYS[step]);
    return () => clearTimeout(t);
  }, [step]);

  return (
    <div className="mx-auto max-w-md rounded-2xl border bg-card p-6 sm:p-8 fade-up" data-testid="menu-analyzing">
      <div className="relative mx-auto mb-6 h-16 w-16">
        <span className="absolute inset-0 animate-ping rounded-2xl bg-[hsl(var(--ai)/0.25)]" />
        <div className="relative flex h-16 w-16 items-center justify-center rounded-2xl bg-[hsl(var(--ai)/0.15)]"><Loader2 className="h-7 w-7 animate-spin text-[hsl(var(--ai))]" /></div>
      </div>
      <ul className="space-y-3">
        {STEPS.map((s, i) => (
          <li key={s} className={`flex items-center gap-3 text-sm transition-opacity duration-500 ${i > step ? "opacity-35" : "opacity-100"}`} data-testid={`menu-analyzing-step-${i}`}>
            <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border ${i < step ? "border-emerald-500 bg-emerald-500 text-white" : i === step ? "border-[hsl(var(--ai))]" : ""}`}>
              {i < step ? <Check className="h-3.5 w-3.5" /> : i === step ? <Loader2 className="h-3.5 w-3.5 animate-spin text-[hsl(var(--ai))]" /> : null}
            </span>
            <span className={i === step ? "font-semibold" : ""}>{s}</span>
          </li>
        ))}
      </ul>
      <div className="mt-6 h-1 overflow-hidden rounded-full bg-muted"><div className="h-full rounded-full bg-[hsl(var(--ai))] transition-[width] duration-1000" style={{ width: `${((step + 1) / (STEPS.length + 0.5)) * 100}%` }} /></div>
      {fileName && <p className="mt-4 truncate text-center text-xs text-muted-foreground">{fileName} {t("analyzingSteps.15_a_30_secondes")}</p>}
    </div>
  );
}
